import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonComponent } from './button.component';
/**
 * NgModule definition for the Button component.
 */
export class ButtonModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
    imports: [CommonModule],
    declarations: [
        ButtonComponent
    ],
    exports: [
        ButtonComponent
    ]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function ButtonModule_tsickle_Closure_declarations() {
/** @type {?} */
ButtonModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
ButtonModule.ctorParameters;
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
